module.exports = __webpack_public_path__ + "img/logo.e5da70b6.png";